// Warte auf das Dokument, um vollständig geladen zu werden
document.addEventListener("DOMContentLoaded", function () {
  // Holen Sie sich eine NodeList aller Radio-Buttons mit der Klasse "sticker-swatch-input"
  var radioButtons = document.querySelectorAll(".sticker-swatch-input");

  // Schleife durch die Radio-Buttons und füge einen Event-Listener hinzu
  radioButtons.forEach(function (radioButton) {
    radioButton.addEventListener("change", function () {
      // Entferne zuerst die Klasse "active" von allen .sticker-swatch-Elementen
      var swatchElements = document.querySelectorAll(".sticker-swatch");
      swatchElements.forEach(function (swatchElement) {
        swatchElement.classList.remove("active");
      });

      // Wenn der Radio-Button ausgewählt ist, füge die Klasse "active" zum Elternelement (.sticker-swatch) hinzu
      if (radioButton.checked) {
        var parentSwatch = radioButton.closest(".sticker-swatch");
        parentSwatch.classList.add("active");
      }
    });
  });

  // Hier fügst du JavaScript-Code ein, um die Bilder zu steuern
  const selectList = document.querySelector('.mw-select-list.is--sticker');
  const swatchContainers = document.querySelectorAll('.image-sticker-wrapper');

  selectList.addEventListener('change', (event) => {
    // Verstecke alle Swatch-Container
    swatchContainers.forEach((container) => {
      container.style.display = 'none';
    });

    // Zeige den ausgewählten Swatch-Container an
    const selectedValue = event.target.value;
    const selectedSwatch = document.getElementById(selectedValue);
    if (selectedSwatch) {
      selectedSwatch.style.display = 'grid'; // Ändere 'flex' zu 'block', wenn dies besser passt.
    }
  });
});